exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".signing-in {\n  width: 100%;\n  min-height: 100vh;\n  background: #2CC185;\n  color: white;\n  text-align: center;\n  line-height: 90vh;\n  font-size: 3em; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/auth/views/microsoftLoginView/microsoftLoginView.component.scss
// module id = ./src/app/modules/auth/views/microsoftLoginView/microsoftLoginView.component.scss
// module chunks = main